import type { IntervalUnit } from '../../types';

import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneComponentsTab');

    const UNIT_LABELS: Record<IntervalUnit, string> = {
        CYCLES: t('cyclesUnit'),
        FLIGHTS: t('flightsUnit'),
        HOURS: t('hoursUnit')
    };

    return {
        NO_INTERVAL: t('noInterval'),
        PART_LABELS: {
            FLOW_METER: t('flowMeterLabel'),
            MOTOR: t('motorLabel'),
            PROPELLER_SET: t('propellerLabel'),
            PUMP: t('pumpLabel')
        } as Record<string, string>,
        SECTION_TITLES: {
            batteryPacks: t('batteryPacks'),
            firmware: t('firmware'),
            flowMeter: t('flowMeter'),
            motors: t('motors'),
            propellers: t('propellers'),
            pumps: t('pumps'),
            radars: t('radars')
        } as Record<string, string>,
        UNIT_LABELS,
        WEAR_DETAIL: ({
            intervalUnit,
            percent,
            remaining
        }: {
            intervalUnit: IntervalUnit;
            percent: number;
            remaining: number;
        }) => t('wearDetail', { percent, remaining, unit: UNIT_LABELS[intervalUnit] })
    };
};

export default useTranslation;
